import React, {useState} from 'react';
import {Box, Button} from "@mui/material";
import { SidePanelContent, SidePanelFooter } from '@securspace/securspace-ui-kit';
import {
  BankBullet,
  BankText,
  MarginBottom,
  MarginTop,
  VerifyTitleSecondary
} from '../../../views/payment/styles/bankInfoStyles';

interface BankAccountConfirmationProps {
  handleModalClose: () => void;
}

const bankArray = [
  'You are one step away from completing the process of adding this payment method.',
  'You must now verify your  bank account by confirming 2 micro deposit amounts.',
  'Two small deposits will be made into your bank account within 1-2 days.',
  'The deposit amount will be less than $0.10.',
  'Once you see the deposits, come back to this page and click the “Verify” button.',
  'Follow the remaining steps to verify and you’re all done!'
];


const enterBankAccountDepositAmounts = [
  'Two deposits were made into your bank account.',
  'Deposit amounts were less than $.10.',
  'Deposits take 1-2 days to appear.'
]


const BankAccountConfirmation = (props: BankAccountConfirmationProps) => {
  const {handleModalClose} = props;
  const [isClickDone] = useState(true);

  return (
    <>
      <SidePanelContent>
        <VerifyTitleSecondary variant='h6'>
          {isClickDone ? `Bank Account Verification Still Required` : `Enter Bank Account Deposit Amounts`}
        </VerifyTitleSecondary>
        <Box sx={{
          width: '100%'
        }}>
          {isClickDone ? bankArray.map((item, index) => (
            <Box display='flex' alignItems='center' key={index}>
              <BankBullet/>
              <BankText variant='body1'>{item}</BankText>
            </Box>
          )) : enterBankAccountDepositAmounts.map((item, index) => (
            <MarginBottom display='flex' alignItems='center' key={index}>
              <BankBullet/>
              <BankText key={index} variant='body1'>{item}</BankText>
            </MarginBottom>
          ))}
          {!isClickDone && <>
            <MarginTop
              type='text'
              placeholder='Enter the first micro deposit amount'
              fullWidth
              label="First Deposit Amount"
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
              id="outlined-basic"
            />
            <MarginTop
              type='text'
              placeholder='Enter second micro deposit amount'
              fullWidth
              label="Second Deposit Amount"
              variant="standard"
              id="outlined-basic"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </>}
        </Box>
      </SidePanelContent>
      <SidePanelFooter>
        {isClickDone ? (
          <Button onClick={handleModalClose} variant='text' color='secondary' type='submit'>
            DONE
          </Button>
        ) : (
          <Button variant='text' color='secondary' type='submit' onClick={handleModalClose}>
            Verify Bank account
          </Button>
        )}
      </SidePanelFooter>
    </>
  )

}

export default BankAccountConfirmation;
